// extracted by mini-css-extract-plugin
module.exports = {"container":"NoFunds_container__2IDXx","subText":"NoFunds_subText__2i5UF","blue":"NoFunds_blue__1pixg"};